import axios from './axiosWrapper';

const AdminDepartmentCategory = {
    getAdminDepartmentCategories() {
        return axios.get(`/department/department-admin-category`)
    },
    getAdminDepartmentCategorySpecialization(id) {
        return axios.get(`/department/specialization-department-admin-category/${id}`)
    },
    listSpecializationBasedAdminDepartmentCategory(id) {
        return axios.get(`/department/list-department-admin-category-specialization/${id}`)
    },
    addDepartmentAdminCategorySpecialization(data) {
        return axios.post('/department/department-admin-category-specialization', data)
    },
    getListOfSpecializations(id) {
        return axios.get(`/department/specialization/${id}`)
    },
    addAdminDepartmentCategory(data) {
        return axios.post('/department/department-admin-category', data)
    },
    updateAdminDepartmentCategory(data, id) {
        return axios.put(`/department/department-admin-category/${id}`, data)
    },
    deleteAdminDepartmentCategory(id) {
        return axios.delete(`/department/department-admin-category/${id}`)
    },
}
export default AdminDepartmentCategory;